import { render, staticRenderFns } from "./parentLogin.vue?vue&type=template&id=5ea940f8&scoped=true"
import script from "./parentLogin.vue?vue&type=script&lang=js"
export * from "./parentLogin.vue?vue&type=script&lang=js"
import style0 from "./parentLogin.vue?vue&type=style&index=0&id=5ea940f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea940f8",
  null
  
)

export default component.exports